import { render, staticRenderFns } from "./InstagramGrid.vue?vue&type=template&id=16ad56a1&"
import script from "./InstagramGrid.vue?vue&type=script&lang=js&"
export * from "./InstagramGrid.vue?vue&type=script&lang=js&"
import style0 from "./InstagramGrid.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SgImg: require('/opt/build/repo/storefront/components/legacy/global/sg-img.vue').default,InstagramPopup: require('/opt/build/repo/storefront/components/molecules/Instagram/InstagramPopup.vue').default})
